import React from 'react';

interface LocationItem {
	id: string;
	code: string;
	name?: string;
	isFound: boolean;
}

interface Location {
	id: string;
	name: string;
	isUnlocked: boolean;
	items?: LocationItem[];
	metaData: {
		position: { x: number; y: number };
		labelPosition: { x: number; y: number };
		svgPath: string;
	};
}

interface JourneyMapOverlayProps {
	locations: Location[];
	mapWidth: number;
	mapHeight: number;
	scale: number;
}

const JourneyMapOverlay: React.FC<JourneyMapOverlayProps> = ({ locations, mapWidth, mapHeight, scale }) => {
	return (
		<svg width={mapWidth} height={mapHeight} viewBox={`0 0 ${mapWidth} ${mapHeight}`} className='absolute top-0 left-0 z-20'>
			<g>
				{locations.map((location) => {
					const unlocked = location.isUnlocked;
					const totalItems = location.items?.length || 0;
					const foundItems = location.items?.filter((item) => item.isFound).length || 0;

					const labelX = (location.metaData.position.x + location.metaData.labelPosition.x + 110) * scale;

					const labelY = (location.metaData.position.y + location.metaData.labelPosition.y + 40) * scale;

					return (
						<g key={location.id}>
							{/* AREA */}
							<path
								transform={`translate(${location.metaData.position.x * scale}, ${location.metaData.position.y * scale}), scale(${scale})`}
								d={location.metaData.svgPath}
								fill={unlocked ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.4)'}
							/>

							{/* LABEL */}
							{location.name && (
								<text
									textAnchor='middle'
									fill='#fff'
									fontFamily='KirangHaerang'
									fontSize={35 * scale}
									style={{
										textShadow: '1px 1px 3px rgba(0,0,0,0.6)',
										pointerEvents: 'none',
									}}
								>
									<tspan x={labelX} y={labelY}>
										{location.name}
									</tspan>

									{totalItems > 0 && (
										<tspan x={labelX} y={labelY + 35 * scale} fontSize={25 * scale} fontFamily='Classic'>
											Found {foundItems}/{totalItems} items
										</tspan>
									)}
								</text>
							)}
						</g>
					);
				})}
			</g>
		</svg>
	);
};

export default JourneyMapOverlay;
